// extracted by mini-css-extract-plugin
export default {"inputs":"BatchItemsSearchForm_inputs__ovQGR","description":"BatchItemsSearchForm_description__JUTtR"};